import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { buildShiftLabel } from '@/utils/shiftDisplay';

const LAST_SHIFTS_LIST = 'LAST_SHIFTS_LIST';
const SHIFT_WORKERS_LIST = 'SHIFT_WORKERS_LIST';
const HISTORY_LIST = 'HISTORY_LIST';
const THERM_DOC_GET = 'THERM_DOC_GET';
const THERM_WORK_ORDER_GET = 'THERM_WORK_ORDER_GET';
const THERM_SHIFT_GET = 'THERM_SHIFT_GET';
const THERM_MASTER_GET = 'THERM_MASTER_GET';
const THERM_LINE_GET = 'THERM_LINE_GET';
const THERM_PREPARED_LIST = 'THERM_PREPARED_LIST';
const THERM_PRODUCT_AFTER_GET = 'THERM_PRODUCT_AFTER_GET';
const THERM_RAW_MATERIALS_LIST = 'THERM_RAW_MATERIALS_LIST';

interface CalculatorState {
    loaded_category: boolean;
    loading_category: boolean;
    consts: any;
    lastShifts: any[];
    shiftWorkersList: any[];
    saveThermizationLoading: boolean;
    printThermizationLoading: boolean;
    historyList: any[];
    historyLoading: boolean;
}

const state: CalculatorState = {
    loading_category: false,
    loaded_category: false,
    lastShifts: [],
    shiftWorkersList: [],
    saveThermizationLoading: false,
    printThermizationLoading: false,
    historyList: [],
    historyLoading: false,

    consts: {
        backet_weight: 0.432,
        m_cheese_before: 70,

        PH_backets_1_class: 4.50,
        PH_baсkets_2_class: 4.35,
        PH_baсkets_3_class: 4.15,

        p_milkstab_1_class: 4.50,
        p_milkstab_2_class: 4.35,
        p_milkstab_3_class: 4.15,

        // PH сгустков
        PH_1: 4.99,
        PH_2: 4.95,
        PH_3: 4.90,
        PH_4: 4.85,
        PH_5: 4.75,
        PH_6: 4.70,
        PH_7: 4.65,
        PH_8: 4.60,
        PH_9: 4.55,
        PH_10: 4.50,
        PH_11: 4.45,
        PH_12: 4.40,
        PH_13: 4.35,
        PH_14: 4.30,
        PH_15: 4.25,
        PH_16: 4.00,

        //дозировки милкстаба 100 (%)
        p_milkstab_1: 0.02,
        p_milkstab_2: 0.06,
        p_milkstab_3: 0.09,
        p_milkstab_4: 0.11,
        p_milkstab_5: 0.13,
        p_milkstab_6: 0.15,
        p_milkstab_7: 0.18,
        p_milkstab_8: 0.21,
        p_milkstab_9: 0.22,
        p_milkstab_10: 0.23,
        p_milkstab_11: 0.24,
        p_milkstab_12: 0.25,
        p_milkstab_13: 0.26,
        p_milkstab_14: 0.27,
        p_milkstab_15: 0.28,
        p_milkstab_16: 0.29,
        milkstab: [
            {max: 4.99, min: 4.95, value: 0.02},
            {max: 4.95, min: 4.90, value: 0.06},
            {max: 4.90, min: 4.85, value: 0.09},
            {max: 4.85, min: 4.75, value: 0.11},
            {max: 4.75, min: 4.70, value: 0.13},
            {max: 4.70, min: 4.65, value: 0.15},
            {max: 4.65, min: 4.60, value: 0.18},
            {max: 4.60, min: 4.55, value: 0.21},
            {max: 4.55, min: 4.50, value: 0.22},
            {max: 4.50, min: 4.45, value: 0.23},
            {max: 4.45, min: 4.40, value: 0.24},
            {max: 4.40, min: 4.35, value: 0.25},
            {max: 4.35, min: 4.30, value: 0.26},
            {max: 4.30, min: 4.25, value: 0.27},
            {max: 4.25, min: 4.00, value: 0.28},
            {max: 4.00, min: 0, value: 0.29},
        ]
    }
};

export const EMPLOYEE_LIST = 'EMPLOYEE_LIST';

function lastShiftsQuery() {
  return {
    columns: {
      id: 'shift.id',
      shift_date: 'shift.shift_date',
      line_name: 'line.name',
    },
    from: 's:shifts',
    from_as: 'shift',
    page_size: 10,
    order: [{ $desc: ['shift.id'] }],
    joins: [
      {
        join: 's:voc_lines',
        type: 'left',
        as: 'line',
        on: { $eq: ['shift.line_id', 'line.id'] },
      },
    ],
  };
}

function shiftWorkersQuery(shiftDocId: string) {
  return {
    columns: {
      id: 'sw.id',
      employee_id: 'employee.id',
      employee_name: 'employee.name',
      is_manager: 'role.is_manager',
    },
    from: 's:shift_workers',
    from_as: 'sw',
    page_size: 1000,
    joins: [
      { join: 's:employees', type: 'left', as: 'employee', on: { $eq: ['sw.employee_id', 'employee.id'] } },
      { join: 's:voc_roles', type: 'left', as: 'role', on: { $eq: ['sw.role_id', 'role.id'] } },
    ],
    order: [{ $asc: ['sw.id'] }],
    where: { $eq: ['sw.shift_id', { $: shiftDocId }] },
  };
}

export const actions: ActionTree<CalculatorState, RootState> = {
    loadLastShifts({ commit }) {
      const vm = (this as any)._vm;
      return vm.$db([
        vm.$q(LAST_SHIFTS_LIST).raw('documents.list').action(lastShiftsQuery()),
      ]).then((result: ServerResult) => {
        const data = result.getOperation(LAST_SHIFTS_LIST).getContent();
        commit('SET_LAST_SHIFTS', data.documents || []);
        if (process.env.NODE_ENV === 'development') {
          console.debug('[Calculator] loadLastShifts', data.documents?.length, 'shifts');
        }
      });
    },

    loadShiftWorkers({ commit }, shiftIdOrDocId: any) {
      if (shiftIdOrDocId == null) {
        commit('SET_SHIFT_WORKERS_LIST', []);
        return Promise.resolve();
      }
      const vm = (this as any)._vm;
      let shiftIdForWhere: string = '';
      if (typeof shiftIdOrDocId === 'object') {
        if (shiftIdOrDocId.pk != null) {
          shiftIdForWhere = `d:shifts:${shiftIdOrDocId.pk}`;
        } else if (shiftIdOrDocId.id?.pk != null) {
          shiftIdForWhere = `d:shifts:${shiftIdOrDocId.id.pk}`;
        } else if (typeof shiftIdOrDocId.id === 'string' && shiftIdOrDocId.id.startsWith('d:')) {
          shiftIdForWhere = shiftIdOrDocId.id;
        } else if (typeof shiftIdOrDocId.id === 'string') {
          const pk = shiftIdOrDocId.id.replace(/^d:[^:]+:/, '') || shiftIdOrDocId.id;
          shiftIdForWhere = pk ? `d:shifts:${pk}` : '';
        }
      } else {
        const str = String(shiftIdOrDocId);
        shiftIdForWhere = str.startsWith('d:') ? str : (str ? `d:shifts:${str.replace(/^d:[^:]+:/, '') || str}` : '');
      }
      if (!shiftIdForWhere) {
        commit('SET_SHIFT_WORKERS_LIST', []);
        return Promise.resolve();
      }
      return vm.$db([
        vm.$q(SHIFT_WORKERS_LIST).raw('documents.list').action(shiftWorkersQuery(shiftIdForWhere)),
      ]).then((result: ServerResult) => {
        const data = result.getOperation(SHIFT_WORKERS_LIST).getContent();
        commit('SET_SHIFT_WORKERS_LIST', data.documents || []);
        if (process.env.NODE_ENV === 'development') {
          console.debug('[Calculator] loadShiftWorkers shift_id=', shiftIdForWhere, 'workers=', data.documents?.length);
        }
      });
    },

    saveThermizationAction({ commit, state }, payload: any) {
      const vm = (this as any)._vm;
      const { saveMeta, product_after_id, calculation_input, calculation_result } = payload;
      const toRelId = (val: any, schema: string): string | null => {
        if (val == null) return null;
        if (typeof val === 'string' && val.startsWith('d:')) return val;
        const pk = val?.pk ?? (typeof val === 'object' && val?.id != null ? String(val.id).replace(/^d:[^:]+:/, '') : val);
        return pk != null && pk !== '' ? `d:${schema}:${pk}` : null;
      };
      const shiftId = saveMeta.shift_id;
      const shiftPk = typeof shiftId === 'object' && shiftId?.pk != null
        ? shiftId.pk
        : (typeof shiftId === 'string' ? shiftId.replace(/^d:[^:]+:/, '') : shiftId);
      const workOrderId = toRelId(saveMeta.work_order_id, 'voc_work_orders');
      const lineId = toRelId(saveMeta.line_id, 'voc_lines');
      const shiftIdStr = shiftPk != null ? `d:shifts:${shiftPk}` : null;
      const masterId = toRelId(saveMeta.master_employee_id, 'employees');
      const toPk = (x: any): number | null => {
        if (x == null) return null;
        let pk: string | number | null = null;
        if (x.pk != null) pk = x.pk;
        else if (typeof x === 'string') pk = x.replace(/^d:[^:]+:/, '') || null;
        else if (typeof x === 'number') pk = x;
        if (pk == null || pk === '') return null;
        const n = typeof pk === 'number' ? pk : parseInt(String(pk), 10);
        return Number.isNaN(n) ? null : n;
      };
      const preparedIds: number[] = Array.isArray(saveMeta.prepared_by_employee_ids)
        ? saveMeta.prepared_by_employee_ids.map(toPk).filter((n: number | null): n is number => n != null)
        : [];
      const productId = toRelId(product_after_id, 'produced_products');
      const calcDt = saveMeta.calculation_datetime
        ? (moment(saveMeta.calculation_datetime).isValid()
          ? moment(saveMeta.calculation_datetime).format('YYYY-MM-DDTHH:mm:ss')
          : null)
        : null;
      if (process.env.NODE_ENV === 'development') {
        console.debug('[Calculator] normalized calculation_datetime=', calcDt);
      }

      commit('SET_SAVE_THERMIZATION_LOADING', true);
      if (process.env.NODE_ENV === 'development') {
        console.debug('[Calculator] saveThermization click', { shiftPk, productId, workOrderId });
      }

      const releaseRows = Array.isArray(saveMeta.release_rows) ? saveMeta.release_rows : [];
      if (process.env.NODE_ENV === 'development') {
        console.debug('[Calculator] saveThermization release_rows count=', releaseRows.length);
      }

      const document = {
        work_order_id: workOrderId,
        calculation_datetime: calcDt,
        line_id: lineId,
        shift_id: shiftIdStr,
        master_employee_id: masterId,
        prepared_by_employee_ids: preparedIds,
        comment: saveMeta.comment || null,
        product_after_id: productId,
        calculation_input: calculation_input || null,
        calculation_result: calculation_result || null,
        release_batch_number: saveMeta.release_batch_number ?? null,
        release_rows: releaseRows,
      };

      return vm.$db([
        vm.$q('SAVE_THERMIZATION').create('thermization_calculation_saves', document),
      ]).then((result: ServerResult) => {
        commit('SET_SAVE_THERMIZATION_LOADING', false);
        const op = result.getOperation('SAVE_THERMIZATION');
        if (op.hasError()) {
          return Promise.reject(new Error((op as any).getError?.()?.message || 'Save failed'));
        }
        const doc = op.getContent();
        if (process.env.NODE_ENV === 'development') {
          console.debug('[Calculator] saveThermization success id=', doc?.id);
        }
        return doc;
      }).catch((err: any) => {
        commit('SET_SAVE_THERMIZATION_LOADING', false);
        return Promise.reject(err);
      });
    },

    getThermizationDocumentAction(_context, payload: { id: string }) {
      const vm = (this as any)._vm;
      const id = payload?.id;
      if (!id) {
        return Promise.reject(new Error('id required'));
      }
      if (process.env.NODE_ENV === 'development') {
        console.debug('[Calculator] getThermizationDocument id=', id);
      }
      const toDocId = (pk: any, schema: string) => {
        if (pk == null || pk === '') return null;
        const raw = pk?.pk ?? pk?.id ?? pk;
        if (typeof raw === 'string' && raw.startsWith('d:')) return raw;
        const n = typeof raw === 'string' ? parseInt(raw, 10) : raw;
        if (typeof n !== 'number' || Number.isNaN(n)) return null;
        return `d:${schema}:${n}`;
      };

      return vm
        .$db([
          vm.$q(THERM_DOC_GET).raw('documents.get').action({ id }),
        ])
        .then((result: ServerResult) => {
          const op = result.getOperation(THERM_DOC_GET);
          if (op.hasError()) {
            const errMsg =
              (op as any).getError?.()?.message ||
              (op as any).getError?.()?.text ||
              'Document not found';
            return Promise.reject(new Error(errMsg));
          }
          const content = op.getContent();
          const document = content?.document;
          if (!document) {
            return Promise.reject(new Error('No document in response'));
          }

          const work_order_id = document?.work_order_id ?? null;
          const shift_id = document?.shift_id ?? null;
          const line_id = document?.line_id ?? null;
          const product_after_id = document?.product_after_id ?? null;
          const master_employee_id = document?.master_employee_id ?? null;
          const prepared_by_employee_ids = Array.isArray(document?.prepared_by_employee_ids)
            ? document.prepared_by_employee_ids
            : [];
          const preparedDocIds = prepared_by_employee_ids
            .map((pid: any) => toDocId(pid?.pk ?? pid?.id ?? pid, 'employees'))
            .filter(Boolean) as string[];

          const shouldFetchWorkOrder = work_order_id != null;
          const shouldFetchShift = shift_id != null;
          const shouldFetchLine = line_id != null;
          const productAfterDocId = toDocId(product_after_id, 'produced_products');
          const shouldFetchProductAfter = productAfterDocId != null;
          const shouldFetchMaster = master_employee_id != null;
          const shouldFetchPrepared = preparedDocIds.length > 0;

          const operations: any[] = [];

          const workOrderDocId = toDocId(work_order_id, 'voc_work_orders');
          if (shouldFetchWorkOrder && workOrderDocId) {
            operations.push(
              vm.$q(THERM_WORK_ORDER_GET).raw('documents.get').action({ id: workOrderDocId })
            );
          }

          const shiftDocId = toDocId(shift_id, 'shifts');
          if (shouldFetchShift && shiftDocId) {
            operations.push(
              vm.$q(THERM_SHIFT_GET).raw('documents.get').action({ id: shiftDocId })
            );
          }

          const lineDocId = toDocId(line_id, 'voc_lines');
          if (shouldFetchLine && lineDocId) {
            operations.push(
              vm.$q(THERM_LINE_GET).raw('documents.get').action({ id: lineDocId })
            );
          }

          if (shouldFetchProductAfter && productAfterDocId) {
            operations.push(
              vm.$q(THERM_PRODUCT_AFTER_GET).raw('documents.get').action({ id: productAfterDocId })
            );
          }

          const masterDocId = toDocId(master_employee_id, 'employees');
          if (shouldFetchMaster && masterDocId) {
            operations.push(
              vm.$q(THERM_MASTER_GET).raw('documents.get').action({ id: masterDocId })
            );
          }

          if (shouldFetchPrepared) {
            operations.push(
              vm.$q(THERM_PREPARED_LIST).raw('documents.list').action({
                columns: {
                  id: 'e.id',
                  name: 'e.name',
                },
                from: 's:employees',
                from_as: 'e',
                page_size: 1000,
                where: {
                  $in: ['e.id', { $: preparedDocIds }],
                },
              })
            );
          }

          if (!operations.length) {
            return {
              ...document,
              work_order_name: null,
              shift_label: null,
              line_name: document?.line_name ?? null,
              product_after_name:
                document?.calculation_input?.after_product?.name ?? null,
              master_name: null,
              prepared_by_names: null,
            };
          }

          return vm.$db(operations).then((result2: ServerResult) => {
            let work_order_name: string | null = null;
            let shift_label: string | null = null;
            let line_name: string | null = document?.line_name ?? null;
            let product_after_name: string | null =
              document?.calculation_input?.after_product?.name ?? null;
            let product_after_ingredients: any[] | null = null;
            let master_name: string | null = null;
            let prepared_by_names: string | null = null;

            if (shouldFetchWorkOrder) {
              try {
                const op2 = result2.getOperation(THERM_WORK_ORDER_GET);
                const c = op2?.getContent?.();
                work_order_name = c?.document?.name ?? null;
              } catch (e) {
                // ignore enrichment failure for non-critical fields
              }
            }

            if (shouldFetchShift) {
              try {
                const op2 = result2.getOperation(THERM_SHIFT_GET);
                const c = op2?.getContent?.();
                const shiftDoc = c?.document;
                if (shiftDoc) {
                  const text = buildShiftLabel(shiftDoc);
                  shift_label = text ? text : null;
                  if (process.env.NODE_ENV === 'development') {
                    console.debug('[Calculator] hydrate shift_label from shift doc');
                  }
                }
              } catch (e) {
                // ignore
              }
            }

            if (shouldFetchLine) {
              try {
                const op2 = result2.getOperation(THERM_LINE_GET);
                const c = op2?.getContent?.();
                line_name = c?.document?.name ?? null;
              } catch (e) {
                // ignore
              }
            }

            if (shouldFetchProductAfter) {
              try {
                const op2 = result2.getOperation(THERM_PRODUCT_AFTER_GET);
                const c = op2?.getContent?.();
                const productDoc = c?.document;
                const nm = c?.document?.name ?? null;
                if (nm != null && String(nm).trim() !== '') {
                  product_after_name = nm;
                }
                if (Array.isArray(productDoc?.ingredients)) {
                  product_after_ingredients = productDoc.ingredients;
                }
              } catch (e) {
                // ignore
              }
            }

            if (shouldFetchMaster) {
              try {
                const op2 = result2.getOperation(THERM_MASTER_GET);
                const c = op2?.getContent?.();
                master_name = c?.document?.name ?? null;
              } catch (e) {
                // ignore
              }
            }

            if (shouldFetchPrepared) {
              try {
                const op2 = result2.getOperation(THERM_PREPARED_LIST);
                const c = op2?.getContent?.();
                const docs: any[] = Array.isArray(c?.documents) ? c.documents : [];
                const nameById: Record<string, string> = {};
                docs.forEach((d: any) => {
                  if (d?.id != null) nameById[String(d.id)] = d?.name;
                });
                prepared_by_names = prepared_by_employee_ids
                  .map((pid: any) => {
                    const docId = toDocId(pid?.pk ?? pid?.id ?? pid, 'employees');
                    return docId ? nameById[docId] : null;
                  })
                  .filter(Boolean)
                  .join(', ');
              } catch (e) {
                // ignore
              }
            }

            const sourceCalcInput = document?.calculation_input;
            let calculation_input = sourceCalcInput ?? null;
            if (sourceCalcInput && typeof sourceCalcInput === 'object') {
              const afterProduct = (sourceCalcInput as any).after_product;
              const currentIngredients = Array.isArray(afterProduct?.ingredients)
                ? afterProduct.ingredients
                : [];
              const hasColorInPayload = currentIngredients.some((ing: any) => {
                return !!(
                  ing?.raw_material?.color ||
                  ing?.raw_material_color ||
                  ing?.raw_material_type_color
                );
              });
              const productAfterIngredients = Array.isArray(product_after_ingredients)
                ? product_after_ingredients
                : [];
              const canEnrichFromProduct =
                !hasColorInPayload && productAfterIngredients.length > 0;
              if (canEnrichFromProduct) {
                const byCode = new Map<string, any>();
                productAfterIngredients.forEach((ing: any) => {
                  const code = String(ing?.code ?? '').trim();
                  if (code) byCode.set(code, ing);
                });
                const mergedIngredients =
                  currentIngredients.length > 0
                    ? currentIngredients.map((ing: any) => {
                        const code = String(ing?.code ?? '').trim();
                        const sourceIng = code ? byCode.get(code) : null;
                        if (!sourceIng) return ing;
                        const sourceRawMaterial =
                          sourceIng?.raw_material && typeof sourceIng.raw_material === 'object'
                            ? sourceIng.raw_material
                            : {};
                        const currentRawMaterial =
                          ing?.raw_material && typeof ing.raw_material === 'object'
                            ? ing.raw_material
                            : {};
                        return {
                          ...sourceIng,
                          ...ing,
                          raw_material: {
                            ...sourceRawMaterial,
                            ...currentRawMaterial,
                            color:
                              currentRawMaterial?.color ??
                              sourceRawMaterial?.color ??
                              null,
                            position:
                              currentRawMaterial?.position ??
                              sourceRawMaterial?.position ??
                              null,
                            id:
                              currentRawMaterial?.id ??
                              sourceRawMaterial?.id ??
                              currentRawMaterial?.pk ??
                              sourceRawMaterial?.pk ??
                              null,
                          },
                          raw_material_type:
                            ing?.raw_material_type ?? sourceIng?.raw_material_type,
                          raw_material_color:
                            ing?.raw_material_color ??
                            sourceIng?.raw_material_color ??
                            currentRawMaterial?.color ??
                            sourceRawMaterial?.color,
                          raw_material_position:
                            ing?.raw_material_position ??
                            sourceIng?.raw_material_position ??
                            currentRawMaterial?.position ??
                            sourceRawMaterial?.position,
                          subgroup: ing?.subgroup ?? sourceIng?.subgroup,
                          subgroup_position:
                            ing?.subgroup_position ?? sourceIng?.subgroup_position,
                          raw_material_type_color:
                            ing?.raw_material_type_color ??
                            sourceIng?.raw_material_type_color ??
                            sourceIng?.raw_material_color ??
                            currentRawMaterial?.color ??
                            sourceRawMaterial?.color,
                          raw_materials_id:
                            ing?.raw_materials_id ??
                            sourceIng?.raw_materials_id ??
                            currentRawMaterial?.id ??
                            sourceRawMaterial?.id ??
                            null,
                        };
                      })
                    : productAfterIngredients;
                calculation_input = {
                  ...sourceCalcInput,
                  after_product: {
                    ...(afterProduct || {}),
                    ingredients: mergedIngredients,
                  },
                };
              }
              if (process.env.NODE_ENV === 'development') {
                console.debug('[Calculator] thermization color source', {
                  source: hasColorInPayload
                    ? 'payload'
                    : canEnrichFromProduct
                      ? 'enriched'
                      : 'none',
                  payloadIngredients: currentIngredients.length,
                  enrichedIngredients: Array.isArray(product_after_ingredients)
                    ? product_after_ingredients.length
                    : 0,
                });
              }
            }

            const toRawMaterialDocId = (ing: any): string | null => {
              const candidate =
                ing?.raw_materials_id ??
                ing?.raw_material_id ??
                ing?.raw_material?.id ??
                ing?.raw_material?.pk ??
                ing?.raw_material;
              return toDocId(candidate, 'voc_raw_materials');
            };
            const buildResponse = (calcInput: any) => ({
              ...document,
              calculation_input: calcInput,
              work_order_name,
              shift_label,
              line_name,
              product_after_name,
              master_name,
              prepared_by_names,
            });
            const ingredientsForColor = Array.isArray(
              (calculation_input as any)?.after_product?.ingredients,
            )
              ? ((calculation_input as any).after_product.ingredients as any[])
              : [];
            const rawMaterialDocIds = Array.from(
              new Set(
                ingredientsForColor
                  .map((ing: any) => toRawMaterialDocId(ing))
                  .filter((id: string | null): id is string => !!id),
              ),
            );
            const rawMaterialPositions = Array.from(
              new Set(
                ingredientsForColor
                  .map((ing: any) => {
                    const pos =
                      ing?.raw_material_position ?? ing?.raw_material?.position;
                    const n = Number(pos);
                    return Number.isFinite(n) ? n : null;
                  })
                  .filter((n: number | null): n is number => n != null),
              ),
            );
            const hasRawMaterialLookup =
              rawMaterialDocIds.length > 0 || rawMaterialPositions.length > 0;
            if (!hasRawMaterialLookup) {
              return buildResponse(calculation_input);
            }
            const whereByIds =
              rawMaterialDocIds.length > 0
                ? { $in: ['rm.id', { $: rawMaterialDocIds }] }
                : null;
            const whereByPositions =
              rawMaterialPositions.length > 0
                ? { $in: ['rm.position', { $: rawMaterialPositions }] }
                : null;
            const rawMaterialWhere =
              whereByIds && whereByPositions
                ? { $or: [whereByIds, whereByPositions] }
                : whereByIds ?? whereByPositions;
            return vm
              .$db([
                vm.$q(THERM_RAW_MATERIALS_LIST).raw('documents.list').action({
                  columns: {
                    id: 'rm.id',
                    name: 'rm.name',
                    color: 'rm.color',
                    position: 'rm.position',
                  },
                  from: 's:voc_raw_materials',
                  from_as: 'rm',
                  page_size: 1000,
                  where: rawMaterialWhere,
                }),
              ])
              .then((result3: ServerResult) => {
                let rawMaterialDocs: any[] = [];
                try {
                  const op3 = result3.getOperation(THERM_RAW_MATERIALS_LIST);
                  const c3 = op3?.getContent?.();
                  rawMaterialDocs = Array.isArray(c3?.documents) ? c3.documents : [];
                } catch (e) {
                  rawMaterialDocs = [];
                }
                const metaById = new Map<string, any>();
                const metaByPosition = new Map<number, any>();
                rawMaterialDocs.forEach((rm: any) => {
                  const id =
                    toDocId(rm?.id ?? rm?.pk, 'voc_raw_materials') ??
                    (typeof rm?.id === 'string' && rm.id.startsWith('d:')
                      ? rm.id
                      : null);
                  if (!id) return;
                  const meta = {
                    id,
                    name: rm?.name ?? null,
                    color: rm?.color ?? null,
                    position: rm?.position ?? null,
                  };
                  metaById.set(id, meta);
                  const posNum = Number(rm?.position);
                  if (Number.isFinite(posNum)) {
                    metaByPosition.set(posNum, meta);
                  }
                });
                const colorizedIngredients = ingredientsForColor.map((ing: any) => {
                  const rmId = toRawMaterialDocId(ing);
                  const posNum = Number(
                    ing?.raw_material_position ?? ing?.raw_material?.position,
                  );
                  const meta =
                    (rmId ? metaById.get(rmId) : null) ??
                    (Number.isFinite(posNum) ? metaByPosition.get(posNum) : null);
                  if (!meta) return ing;
                  const rawMaterial =
                    ing?.raw_material && typeof ing.raw_material === 'object'
                      ? ing.raw_material
                      : {};
                  return {
                    ...ing,
                    raw_materials_id: ing?.raw_materials_id ?? meta.id,
                    raw_material: {
                      ...rawMaterial,
                      id: rawMaterial?.id ?? meta.id,
                      name: rawMaterial?.name ?? meta.name,
                      position: rawMaterial?.position ?? meta.position,
                      color: rawMaterial?.color ?? meta.color,
                    },
                    raw_material_color: ing?.raw_material_color ?? meta.color,
                    raw_material_position:
                      ing?.raw_material_position ?? meta.position,
                    raw_material_type: ing?.raw_material_type ?? meta.name,
                    raw_material_type_color:
                      ing?.raw_material_type_color ?? meta.color,
                  };
                });
                const calcInputWithRawMaterialColor =
                  calculation_input && typeof calculation_input === 'object'
                    ? {
                        ...calculation_input,
                        after_product: {
                          ...((calculation_input as any).after_product || {}),
                          ingredients: colorizedIngredients,
                        },
                      }
                    : calculation_input;
                if (process.env.NODE_ENV === 'development') {
                  const coloredCount = colorizedIngredients.filter((ing: any) => {
                    return !!(
                      ing?.raw_material?.color ||
                      ing?.raw_material_color ||
                      ing?.raw_material_type_color
                    );
                  }).length;
                  console.debug('[Calculator] thermization raw material color enrichment', {
                    ingredientCount: colorizedIngredients.length,
                    rawMaterialDocIds: rawMaterialDocIds.length,
                    rawMaterialPositions: rawMaterialPositions.length,
                    rawMaterialDocs: rawMaterialDocs.length,
                    coloredCount,
                  });
                }
                return buildResponse(calcInputWithRawMaterialColor);
              })
              .catch((_err: any) => buildResponse(calculation_input));
          });
        });
    },

    loadHistory({ commit, state }, filters: any) {
      const vm = (this as any)._vm;
      // Date pickers are local dates; saved_at is handled as UTC in UI.
      // Convert local day boundaries to UTC to avoid off-by-timezone empty results.
      const since = filters?.since
        ? moment(filters.since).startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss')
        : null;
      const until = filters?.until
        ? moment(filters.until).endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss')
        : null;
      const productId = filters?.product_after_id;
      const lineId = filters?.line_id;
      const savedById = filters?.saved_by_id;
      const workOrderId = filters?.work_order_id;
      const page = Math.max(1, parseInt(String(filters?.page || 1), 10) || 1);
      const pageSize = Math.min(100, Math.max(1, parseInt(String(filters?.page_size || 10), 10) || 10));
      const sortField = filters?.sort_field || filters?.sortField || 'saved_at';
      const sortOrderRaw = (filters?.sort_order || filters?.sortOrder || 'desc') as string;
      const sortDesc = String(sortOrderRaw).toLowerCase() !== 'asc';

      const toRelId = (val: any, schema: string): string | null => {
        if (val == null) return null;
        if (typeof val === 'string' && val.startsWith('d:')) return val;
        const pk = val?.pk ?? val?.id ?? val;
        const raw = (typeof pk === 'object' && pk != null && pk.pk != null) ? pk.pk : pk;
        if (raw == null || raw === '') return null;
        const pkStr = typeof raw === 'string' && raw.startsWith('d:') ? raw.replace(/^d:[^:]+:/, '') : String(raw);
        return pkStr ? `d:${schema}:${pkStr}` : null;
      };
      const productIdStr = toRelId(productId, 'produced_products');
      const lineIdStr = toRelId(lineId, 'voc_lines');
      const savedByStr = toRelId(savedById, 'employees');
      const workOrderStr = toRelId(workOrderId, 'voc_work_orders');

      const sortColumnMap: Record<string, string> = {
        saved_at: 'tcs.saved_at',
        work_order_name: 'work_order.name',
        saved_by_name: 'saved_by.name',
        product_after_name: 'product_after.name',
        comment: 'tcs.comment',
      };
      const orderCol = sortColumnMap[sortField] || 'tcs.saved_at';
      const orderClause = sortDesc ? { $desc: [orderCol] } : { $asc: [orderCol] };

      commit('SET_HISTORY_LOADING', true);
      if (process.env.NODE_ENV === 'development') {
        console.debug('[Calculator] loadHistory filters', {
          since, until, productIdStr, lineIdStr, savedByStr, workOrderStr, page, pageSize, sortField, sortDesc,
        });
      }

      const where: any[] = [];
      if (since) where.push({ $gte: ['tcs.saved_at', { $: since }] });
      if (until) where.push({ $lte: ['tcs.saved_at', { $: until }] });
      if (productIdStr) where.push({ $eq: ['tcs.product_after_id', { $: productIdStr }] });
      if (lineIdStr) where.push({ $eq: ['tcs.line_id', { $: lineIdStr }] });
      if (savedByStr) where.push({ $eq: ['tcs.saved_by_id', { $: savedByStr }] });
      if (workOrderStr) where.push({ $eq: ['tcs.work_order_id', { $: workOrderStr }] });

      const query = {
        columns: {
          id: 'tcs.id',
          calculation_datetime: 'tcs.calculation_datetime',
          saved_at: 'tcs.saved_at',
          saved_by_name: 'saved_by.name',
          work_order_name: 'work_order.name',
          product_after_name: 'product_after.name',
          comment: 'tcs.comment',
          line_name: 'line.name',
        },
        from: 's:thermization_calculation_saves',
        from_as: 'tcs',
        page_size: pageSize,
        page,
        order: [orderClause],
        joins: [
          { join: 's:employees', type: 'left', as: 'saved_by', on: { $eq: ['tcs.saved_by_id', 'saved_by.id'] } },
          { join: 's:produced_products', type: 'left', as: 'product_after', on: { $eq: ['tcs.product_after_id', 'product_after.id'] } },
          { join: 's:voc_lines', type: 'left', as: 'line', on: { $eq: ['tcs.line_id', 'line.id'] } },
          { join: 's:voc_work_orders', type: 'left', as: 'work_order', on: { $eq: ['tcs.work_order_id', 'work_order.id'] } },
        ],
        ...(where.length > 1 ? { where: { $and: where } } : where.length === 1 ? { where: where[0] } : {}),
      };

      return vm.$db([
        vm.$q(HISTORY_LIST).raw('documents.list').action(query),
      ]).then((result: ServerResult) => {
        const op = result.getOperation(HISTORY_LIST);
        const data = op ? op.getContent() : null;
        const docs = Array.isArray(data?.documents) ? data.documents : (data?.result && Array.isArray(data.result.documents) ? data.result.documents : []);
        const list = docs.filter((r: any) => r != null);
        const meta = data?.meta || {};
        commit('SET_HISTORY_LIST', list);
        commit('SET_HISTORY_LOADING', false);
        if (process.env.NODE_ENV === 'development') {
          console.debug('[Calculator] loadHistory rows=', list.length, 'meta=', meta);
        }
        return { list, meta };
      }).catch((err: any) => {
        commit('SET_HISTORY_LOADING', false);
        return { list: [], meta: {} };
      });
    },

    weightCalc({ commit, getters, dispatch, state }, plan) {
      const vm = (this as any)._vm;
  
      return new Promise((resolve, reject) => {
          vm.$db([
              vm.$q('CALC')
              .raw('documents.calculate')
              .action({plan})
          ]).then(((result: ServerResult) => {
              const exportOpContent = result.getOperation('CALC').getContent();
  
              resolve(exportOpContent.result);
          }));
      })
    },

};

export const mutations: MutationTree<CalculatorState> = {
    START_LOADING_CATEGORY: (state) => {
        state.loaded_category = false;
        state.loading_category = true;
    },
    LOADED_SUCCESS_CATEGORY: (state) => {
        state.loaded_category = true;
        state.loading_category = false;
    },
    SET_LAST_SHIFTS: (state, list: any[]) => {
        state.lastShifts = list;
    },
    SET_SHIFT_WORKERS_LIST: (state, list: any[]) => {
        state.shiftWorkersList = list;
    },
    SET_SAVE_THERMIZATION_LOADING: (state, value: boolean) => {
        state.saveThermizationLoading = value;
    },
    SET_PRINT_THERMIZATION_LOADING: (state, value: boolean) => {
        state.printThermizationLoading = value;
    },
    SET_HISTORY_LIST: (state, list: any[]) => {
        state.historyList = list;
    },
    SET_HISTORY_LOADING: (state, value: boolean) => {
        state.historyLoading = value;
    },
};

const getters: GetterTree<CalculatorState, RootState> = {

};

export const STORE_KEY = '$_calculator';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
